// extracted by mini-css-extract-plugin
module.exports = {"container":"_839836b","imageContainer":"_bbccb0b","minSizeClientImage":"_a037923","content":"_fc0cd96","buttonContainer":"_7c96556"};